import React from 'react';
import { Row, Col } from 'reactstrap';
import { updateLanguage, updateModalLanguage } from 'store/apps/appConfig';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { translationFlags } from 'config/translationFlags';
import CustomCard from 'components/common/cards/customCard';
import NavigationTitle from '../navigationTitle';
import { ReactComponent as Power } from 'assets/images/logos/PoweredByLokk.svg';
import { colors } from 'config/colors';


const LanguageModal = () => {

  const dispatch = useDispatch();
  const { t } = useTranslation();
  const {language} = useSelector(state => state?.appConfig)

  const changeCountry = (country) => {
    dispatch(updateLanguage(country?.code));
    dispatch(updateModalLanguage(false))
  }

  return (
    <Row className='m-0 h-100 w-100'>
      <Power style={{ width: "90px", height: "20px", bottom: 10, left: "calc(50% - 45px)",fill:colors.font }} className="m-0 m p-0 position-absolute" />
      <Col xs="12" style={{ height: "17.1%" }}>
        <NavigationTitle title={t('app.language')} modal modalLanguage />
      </Col>
      <Col xs="12" style={{ height: "82.9%" }} >
        <Row className='mt-4'>
          {translationFlags.map((item, index) =>
            <Col key={index} xs="12" className='my-2' onClick={() => changeCountry(item)}>
              <CustomCard color={language === item?.code ? "dark" : "secondary"}>
                <div className="m-0 p-0 p-3 w-100 h-fit-content d-flex flex-row">
                  <div className='m-0 p-0' style={{ width: "32.5px" }}>{item?.flag}</div>
                  <div className='m-0 p-0 d-flex align-items-center ps-3 text-4 weight-300'>{item?.language}</div>
                </div>
              </CustomCard>
            </Col>
          )}
        </Row>
      </Col>
    </Row>
  );
}

export default LanguageModal;
